import styled from 'styled-components';

import {
  LANDING_BREAKPOINT,
  LARGE_SCREEN_BREAKPOINT,
} from '@utils/theme/breakPoint';

export const BookerSearchInputWrapper = styled.div<{ height?: number }>`
  max-height: 440px !important;
  overflow: auto !important;
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${({ theme }) => theme.palette.gray};
    border-radius: 10px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette.brownishGrey};
    border-radius: 10px;
  }
  .react-tiny-popover-container {
    width: 570px !important;
    top: -25px !important;
    @media (max-width: ${LANDING_BREAKPOINT}) and (min-width: ${LARGE_SCREEN_BREAKPOINT}) {
      width: 500px !important;
    }
  }
`;
